import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import consumer from '../../../channels/consumer'
import { columnCardsQueryKey } from './useColumnCards'

function useKanbanChannel(boardId) {
  const queryClient = useQueryClient()

  useEffect(() => {
    if (!boardId) return

    const invalidateColumn = (columnId) => {
      if (columnId == null) return
      queryClient.invalidateQueries({ queryKey: columnCardsQueryKey(columnId) })
    }
    const invalidateBoard = () => {
      queryClient.invalidateQueries({ queryKey: ['kanbanBoard', boardId] })
      queryClient.invalidateQueries({ queryKey: ['kanbanBoards'] })
    }
    const invalidateFacets = () => {
      queryClient.invalidateQueries({ queryKey: ['kanbanBoardFacets', boardId] })
      queryClient.invalidateQueries({ queryKey: ['kanbanBoardSearch', boardId] })
    }

    const subscription = consumer.subscriptions.create(
      { channel: 'KanbanBoardChannel', board_id: boardId },
      {
        received(data) {
          const { action } = data
          const payload = data.data || {}

          switch (action) {
            case 'card_created':
              invalidateColumn(payload.kanban_column_id)
              invalidateFacets()
              break
            case 'card_updated':
              invalidateColumn(payload.kanban_column_id)
              invalidateFacets()
              break
            case 'card_moved':
              invalidateColumn(payload.kanban_column_id)
              if (payload.from_kanban_column_id && payload.from_kanban_column_id !== payload.kanban_column_id) {
                invalidateColumn(payload.from_kanban_column_id)
              }
              break
            case 'card_deleted':
              invalidateColumn(payload.kanban_column_id)
              invalidateFacets()
              break
            case 'column_cleared':
              invalidateColumn(payload.id)
              invalidateFacets()
              break
            case 'column_created':
            case 'column_updated':
            case 'column_deleted':
            case 'board_updated':
            case 'collaborator_changed':
              invalidateBoard()
              invalidateFacets()
              break
            default:
              break
          }
        }
      }
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [boardId, queryClient])
}

export default useKanbanChannel
